module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"go_to":"Ir a inicio","line_1":"Página no encontrada","line_2":"Lo sentimos, la página que buscas no","line_3":"Existe o no se puede encontrar.","main_message":"404!!!"}}')
  delete Component.options._Ctor
}
